var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[(_vm.isObjectPage)?_c('ObjectPageHeaderMobile'):_c('PageHeaderMobile'),_c('MobileLeftMenu'),_c('MobileRightMenu')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }